import svgJs from "svg.js/dist/svg";
import {
    closeModal,
    createButton,
    createButtonContainer,
    createCaption,
    createModal,
    createModalOverlay,
    createText
} from "./scripts/modal";

export default {
    install(Vue, options) {
        Vue.prototype.$svg = svgJs

        Vue.prototype.$showError = function (message, timeout) {
            if (!isNaN(message) && !timeout) {
                timeout = Number(message);
            }

            if (!timeout) {
                timeout = 3000;
            }

            if (!message || !isNaN(message)) {
                message = 'Something went wrong. Incorrect request!';
            }

            this.$notify({
                message: message,
                type: 'danger',
                timeout: timeout
            });
        }

        Vue.prototype.$showSuccess = function (message, timeout) {
            if (!message) {
                message = 'Operation success!';
            }

            if (!timeout) {
                timeout = 3000;
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: timeout
            });
        }

        Vue.prototype.$getTriathlonId = function (id) {
            return id - 100000 + 10000000;
        }

        Vue.prototype.$getUIDFromMemberNumber = function (id) {
            return id + 100000 - 10000000;
        }

        Vue.prototype.$console = function (message) {
            if (console && console.log) {

                if (message) {
                    const currentPath = this.$route.matched.find(route => route.path === this.$route.path);
                    console.log('MESSAGE: ');
                    console.log(message);
                    if (currentPath && currentPath.components) console.log('PATH: ' + currentPath.components.default.__file);
                }
                else {
                    const date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        }

        Vue.prototype.$mobileAndTabletCheck = function(){
            var toMatch = [
                /Android/i,
                /webOS/i,
                /iPhone/i,
                /iPad/i,
                /iPod/i,
                /BlackBerry/i,
                /Windows Phone/i
            ];
            return toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem);
            });
        }

        Vue.prototype.$modal = ({
            caption,
            text,
            confirmFn,
            confirmText = 'Confirm',
            cancelFn,
            cancelText = 'Cancel'
        }) => {
            // Create modal elements
            const modalOverlay = createModalOverlay();

            // handle clicking outside the modal
            modalOverlay.onclick = (event) => {
                if (event.target === modalOverlay) {
                    cancelFn();
                    closeModal(modalOverlay);
                }
            };
            const modal = createModal();

            // create caption/text
            const captionElem = createCaption(caption);
            const textElem = createText(text);

            // create buttons
            const buttonContainer = createButtonContainer();
            const cancelButton = createButton({
                text: cancelText,
                cssClass: 'btn btn-danger mr-2',
                invokeFn: () => {
                    cancelFn();
                    closeModal(modalOverlay)
                },
            });

            const confirmButton = createButton({
                text: confirmText,
                cssClass: 'btn btn-success',
                invokeFn: () => {
                    confirmFn();
                    closeModal(modalOverlay)
                },
            })

            // append it all to container/body
            buttonContainer.appendChild(cancelButton);
            buttonContainer.appendChild(confirmButton);

            modal.appendChild(captionElem);
            modal.appendChild(textElem);
            modal.appendChild(buttonContainer);
            modalOverlay.appendChild(modal);
            document.body.appendChild(modalOverlay);
        }

        Vue.filter('price', function (value) {
            const num = Number(value);

            if (value == null || value === '' || isNaN(num)) {
                return '0.00';
            }

            return new Intl.NumberFormat('en-IE', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(num);
        })

        Vue.filter('longDate', function (value) {
            if (!value) {
                return '';
            }

            const date = new Date(value);

            if (isNaN(date.getTime())) {
                return '';
            }

            return new Intl.DateTimeFormat('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }).format(date);
        })
    }
}



// WEBPACK FOOTER //
// ./src/CommonPlugin.js